module.exports = __webpack_public_path__ + "static/media/verify-listing.e35f242c.svg";